// 레버리지·인버스 ETF 판정 (순수 함수 · 2026-07-26)
//
// 배경: 체결 route에는 심볼 화이트리스트가 없어 TQQQ·SQQQ 같은 3배 상품이 아무 표시 없이 매수됐다.
//   유니버스 게이트(lib/sotda/universeGate.js)는 시총 기준이라 미국 종목을 전부 exempt로 통과시켜
//   레버리지에 대해서는 판정 자체를 하지 않는다.
// 결정(효신님 2026-07-26): **차단하지 않고 경고 배지만.** 2026-06-21 "종목 선택 자유 보존,
//   교육적 경고만" 결정과 같은 강도로 맞춘다.
//
// 판정 근거는 **정식명**이 1순위다. 티커 세트는 이름을 못 받은 경로(보유 종목 등)를 위한 보조이고,
//   여기 적힌 티커·정식명은 전부 프로덕션 `/api/market/search` 실호출로 확인했다(2026-07-26).
//   ⚠ 검증하지 않은 티커를 추측으로 추가하지 말 것 — 이름 규칙만으로도 대부분 잡힌다.

/** 실검증된 대표 레버리지·인버스 ETF 티커 (이름이 없는 경로용 보조 판정) */
const KNOWN_LEVERAGED = new Set([
  'TQQQ', 'SQQQ', 'QLD', 'SOXL', 'SOXS', 'UPRO', 'SPXU',
  'TNA', 'TZA', 'LABU', 'YINN', 'UVXY', 'TSLL', 'NVDL',
]);

// 정식명 규칙 — 실측 표본:
//   ProShares UltraPro QQQ / ProShares UltraPro Short QQQ / ProShares Ultra QQQ
//   Direxion Daily Semiconductor Bull 3X Shares / ... Bear 3X Shares
//   GraniteShares 2x Long NVDA Daily ETF / ProShares Ultra VIX Short-Term Futures ETF
// ⚠ `short` 단독은 금지 — "Portfolio Short Term Treasury"(만기 짧은 채권)를 오탐한다.
const NAME_PATTERNS: RegExp[] = [
  /\bultra(pro|short)?\b/i,          // Ultra · UltraPro · UltraShort
  /\d(\.\d)?\s*x\b/i,                // 3X · 2x · 1.5X
  /\b(bull|bear)\s*\d/i,             // Bull 3X · Bear 3X
  /\b(leveraged|inverse)\b/i,
];

/**
 * 레버리지·인버스 ETF인가? (순수 함수)
 * @param input.symbol 티커(대소문자 무관)
 * @param input.name   정식명. 있으면 이름 규칙이 1순위.
 */
export function isLeveragedEtf({ symbol, name }: { symbol?: string; name?: string } = {}): boolean {
  const t = String(symbol || '').trim().toUpperCase();
  if (t && KNOWN_LEVERAGED.has(t)) return true;
  const n = String(name || '').trim();
  if (!n) return false;
  return NAME_PATTERNS.some((re) => re.test(n));
}

/** 배지·경고 문구 단일 출처 — 화면마다 다르게 쓰지 않도록 여기서만 정의한다. */
export const LEVERAGED_BADGE = '레버리지';
export const LEVERAGED_WARNING =
  '레버리지·인버스 상품이에요. 하루 수익률의 2~3배를 따라가도록 만들어져, 오래 들고 있으면 지수가 제자리로 와도 원금이 줄어들 수 있어요.';
